import {rawRenderingLib, RenderingServices} from '@wallaby-ui/core';
import {ICellRendererParams} from 'ag-grid-community';
import classNames from 'classnames';

import entityLinkRenderer from './entity_link_renderer';
import styles from 'src/js/common/components/formatters/IconSpanWrapperLinkFormatter.less';
import stylesLinkFormatter from 'src/js/common/components/formatters/LinkFormatter.less';
import {ROUTE_PATIENTS} from 'src/js/containers/patient/patient_constants';
import {basePatientListLinkFormatterParams} from 'src/js/lib/raw_rendering/base_patient_list_link_formatter_params';

/**
 * Returns raw DOM element version of EncounterLinkFormatter component.
 * @param params
 * @param services
 * @returns {Element}
 */
export function patientListLinkFormatter(
  params: ICellRendererParams,
  services: RenderingServices
) {
  const {id, label, titleText} = basePatientListLinkFormatterParams(
    params,
    services
  );

  const iconClass = 'fas fa-bed';

  const spanElem = document.createElement('span');
  spanElem.className = styles.dlSpanWrapper;

  const iconElem = `<i class="${classNames(iconClass, styles.dlIconLink)}" />`;
  rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(spanElem, iconElem);

  const divElem = document.createElement('div');
  divElem.className = stylesLinkFormatter.dlLinkFormatter;
  const textElem = rawRenderingLib.plainTextOrHtmlRenderer({
    showHtml: true,
    text: label,
    className: stylesLinkFormatter.dlLinkFormatterText,
  });
  const linkElem = entityLinkRenderer(
    {
      id,
      route: ROUTE_PATIENTS,
      titleText,
      suppressPadding: true,
      children: textElem,
    },
    services
  );
  rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(divElem, linkElem);
  rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(spanElem, divElem);

  return spanElem;
}
